import { Id } from '@/fx/Id';

import { CLM } from '@/common/schema/claims';
import { CLP } from '@/common/schema/claims-process';

export namespace SAMPLE_DATA {

  export const RC_NOVICE      = Id.from(101n) as CLM.UserId;
  export const WCA_NOVICE     = Id.from(102n) as CLM.UserId;
  export const RC_PRO         = Id.from(103n) as CLM.UserId;
  export const RC_EXP         = Id.from(105n) as CLM.UserId;
  export const WCA_EXP        = Id.from(106n) as CLM.UserId;

  export const WCA_PRO        = Id.from(201n) as CLM.UserId;
  export const WCA_AS_PRO     = Id.from(202n) as CLM.UserId;
  export const ARS_PRO        = Id.from(203n) as CLM.UserId;
  export const WS_PRO         = Id.from(204n) as CLM.UserId;
  export const SYS_PRO        = Id.from(205n) as CLM.UserId;

  export const BBC_APR_NOVICE = Id.from(301n) as CLM.UserId;
  export const DIS_NOVICE     = Id.from(302n) as CLM.UserId;

  export const DEFAULT_USER_ID = RC_PRO;

  export class DataGenerator
  {
    get seedWholesalers() { return seedWholesalers };
    get seedClaims     () { return seedClaims      };
  }

// #region Seed Users

  const shouldHaveExperimentalSettings = (_: CLM.User) => [RC_EXP, WCA_EXP].includes(_.id);

  const experimentalSettings = {
    showOverdue:                 true,
    hideDraftsWhenEmpty:         true,
    dueDateAlert_inBusinessDays: 10,
  };

  const seedUsers: CLM.User[] = [
    { id: RC_NOVICE,      name: "Jill Novice RC",        settings: { experience: CLM.Experience.NOVICE, persona: CLP.ActorType.RETURNS_COORDINATOR                    }} as CLM.User,
    { id: WCA_NOVICE,     name: "Jack Novice WCA",       settings: { experience: CLM.Experience.NOVICE, persona: CLP.ActorType.WHOLESALER_CREDIT_ACCOUNTANT           }} as CLM.User,
    { id: RC_PRO,         name: "Michael Pro RC",        settings: { experience: CLM.Experience.PRO,    persona: CLP.ActorType.RETURNS_COORDINATOR                    }} as CLM.User,
    { id: WCA_PRO,        name: "Samantha Pro WCA",      settings: { experience: CLM.Experience.PRO,    persona: CLP.ActorType.WHOLESALER_CREDIT_ACCOUNTANT           }} as CLM.User,
    { id: RC_EXP,         name: "John Pro RC with EXP",  settings: { experience: CLM.Experience.PRO,    persona: CLP.ActorType.RETURNS_COORDINATOR                    }} as CLM.User,
    { id: WCA_EXP,        name: "Jane Pro WCA with EXP", settings: { experience: CLM.Experience.PRO,    persona: CLP.ActorType.WHOLESALER_CREDIT_ACCOUNTANT           }} as CLM.User,
    { id: WCA_AS_PRO,     name: "Sally Pro WCA_AS",      settings: { experience: CLM.Experience.PRO,    persona: CLP.ActorType.WHOLESALER_CREDIT_ACCOUNTANT_ASSISTANT }} as CLM.User,
    { id: ARS_PRO,        name: "Alice Pro ARS",         settings: { experience: CLM.Experience.PRO,    persona: CLP.ActorType.ACCOUNTS_RECEIVABLE_SUPERVISOR         }} as CLM.User,

    { id: BBC_APR_NOVICE, name: "Bob Novice BBC_APR",    settings: { experience: CLM.Experience.NOVICE, persona: CLP.ActorType.BBC_APPROVER                           }} as CLM.User,
    { id: DIS_NOVICE,     name: "Bran Novice DIS",       settings: { experience: CLM.Experience.NOVICE, persona: CLP.ActorType.DISTRIBUTOR                            }} as CLM.User,
    { id: WS_PRO,         name: "Brent Manijer WS PRO",  settings: { experience: CLM.Experience.PRO,    persona: CLP.ActorType.DISTRIBUTOR                            }} as CLM.User,
    { id: SYS_PRO,        name: "Tron SYS PRO",          settings: { experience: CLM.Experience.PRO,    persona: CLP.ActorType.SYSTEM                                 }} as CLM.User,
  ].map(_ => ({
    ..._,
    experimentalSettings: shouldHaveExperimentalSettings(_) ? experimentalSettings : undefined,
  }));

// #endregion
// #region Seeds Wholesalers and Claims

  const seedWholesalers: CLM.Wholesaler[] = [];
  const seedClaims:      CLM.Claim[]      = [];

// #endregion
}
